module.exports = __webpack_public_path__ + "static/media/banner-left.ed3b6e20.png";